import { useState, useEffect } from "react";
import {
  isSoundEnabled,
  toggleSoundEffects,
  SoundEffect,
  playSound,
} from "@/lib/soundEffects";

const SoundToggleButton = () => {
  const [enabled, setEnabled] = useState(isSoundEnabled());
  const [isVisible, setIsVisible] = useState(false);

  // Set initial state and animate in
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 2000); // Wait 2 seconds before showing

    return () => clearTimeout(timeout);
  }, []);

  const toggleSound = () => {
    const newState = toggleSoundEffects();
    setEnabled(newState);

    // Play sound if turning on
    if (newState) {
      playSound(SoundEffect.CLICK);
    }
  };

  return (
    <button
      className={`fixed bottom-4 right-4 z-50 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all duration-300 
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}
      onClick={toggleSound}
      title={enabled ? "Mute sound effects" : "Enable sound effects"}
      aria-label={enabled ? "Mute sound effects" : "Enable sound effects"}
    >
      {enabled ? (
        <SoundOnIcon className="w-5 h-5 text-white" />
      ) : (
        <SoundOffIcon className="w-5 h-5 text-white" />
      )}
    </button>
  );
};

// Sound On Icon
const SoundOnIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
  </svg>
);

// Sound Off Icon
const SoundOffIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" />
    <line x1="23" y1="9" x2="17" y2="15" />
    <line x1="17" y1="9" x2="23" y2="15" />
  </svg>
);

export default SoundToggleButton;
